import {
  selectAiPersona as selectAiPersonaImpl,
  selectHasUnlimitedChat,
  selectHasVoiceAccess,
  selectOracleToastDismissedContentId,
} from './selectors'
// Persona id constants live in the consolidated source of truth
// (./personalities, AI-820 / CS3a).
import {
  PERSONALITY_ARCHITECT_ID as PERSONALITY_ARCHITECT_ID_IMPL,
  PERSONALITY_SAGE_ID as PERSONALITY_SAGE_ID_IMPL,
  DEFAULT_PERSONALITY_ID as DEFAULT_PERSONALITY_ID_IMPL,
} from './personalities'

export { selectHasUnlimitedChat, selectHasVoiceAccess, selectOracleToastDismissedContentId }
export { setOraclePersona, setOracleGuideToastDismissed } from './actions'

// Locally re-bound rather than re-exported via `export { ... } from './selectors'`.
// Tests (PostHogProvider.unit.tsx) use `td.replace` against this export; a direct
// re-export produces a getter-only binding that testdouble cannot replace, whereas
// a local `const` re-binding gives testdouble a property it can swap. The persona
// id constants below are re-bound the same way for consistency.
export const selectAiPersona = selectAiPersonaImpl

export const PERSONALITY_ARCHITECT_ID = PERSONALITY_ARCHITECT_ID_IMPL
export const PERSONALITY_SAGE_ID = PERSONALITY_SAGE_ID_IMPL
export const DEFAULT_PERSONALITY_ID = DEFAULT_PERSONALITY_ID_IMPL
